export const t = (key, fallback = "") => {
  const dict = window.themeSettings?.i18n || {};
  return dict[key] || fallback;
};

export const tf = (key, fallback = "", replacements = {}) => {
  let text = t(key, fallback);

  Object.entries(replacements).forEach(([placeholder, value]) => {
    text = text.replaceAll(`%{${placeholder}}`, String(value));
  });

  return text;
};
